(function () {
  "use strict";
  var doc = document, PAGE = doc.querySelector("[data-campaign]") || doc.body;
  var CAMPAIGN = PAGE.getAttribute("data-campaign") || "", VARIANT = PAGE.getAttribute("data-variant") || "";

  /* ---- 1. Campaign parameters: keep them for the product-page link and the cart ---- */
  var KEEP = /^(utm_|fbclid$|gclid$|ttclid$|cs_)/;
  var incoming = new URLSearchParams(location.search), carried = [];
  incoming.forEach(function (v, k) { if (KEEP.test(k)) carried.push([k, v]); });
  if (carried.length) {
    doc.querySelectorAll("a[data-cta]").forEach(function (a) {
      var u = new URL(a.href);
      carried.forEach(function (kv) { if (!u.searchParams.has(kv[0]) || kv[0] === "fbclid") u.searchParams.set(kv[0], kv[1]); });
      a.href = u.toString();
    });
  }

  /* ---- 2. Analytics: dataLayer + Mouseflow tags + DOM event. No vendor code beyond the Mouseflow snippet. ---- */
  function track(name, detail) {
    var payload = Object.assign({ event: "cs_" + name, campaign: CAMPAIGN, variant: VARIANT }, detail || {});
    if (window.dataLayer && typeof window.dataLayer.push === "function") window.dataLayer.push(payload);
    if (window._mfq) { window._mfq.push(["tag", "cs_" + name + (detail && detail.label ? ":" + detail.label : "")]); }
    doc.dispatchEvent(new CustomEvent("cs:track", { detail: payload }));
  }
  if (window._mfq) { window._mfq.push(["setVariable", "cs_campaign", CAMPAIGN]); window._mfq.push(["setVariable", "cs_variant", VARIANT]); }
  doc.addEventListener("click", function (e) {
    var el = e.target.closest("[data-cs-event]");
    if (el && el.getAttribute("data-cs-event") !== "add_to_cart") track(el.getAttribute("data-cs-event"), { label: el.getAttribute("data-cs-label") || "" });
  });
  track("lp_view");
  /* pdp_click: every click through to a product or collection page (the goal of click-through pages) */
  doc.addEventListener("click", function (e) {
    var a = e.target.closest("a[href]"); if (!a) return;
    try { var u = new URL(a.href, location.href); if (/^\/(products|collections)\//.test(u.pathname)) track("pdp_click", { label: a.getAttribute("data-cs-label") || u.pathname }); } catch (err) { /* ignore */ }
  });
  /* Live price and availability on product cards (data-live-handle), for pages that link out instead of selling in place */
  doc.querySelectorAll("[data-live-handle]").forEach(function (card) {
    var h = card.getAttribute("data-live-handle"), store = card.getAttribute("data-store") || ""; if (!h) return;
    fetch(store + "/products/" + h + ".js", { mode: "cors" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var pr = card.querySelector("[data-live-card=price]"), av = card.querySelector("[data-live-card=avail]");
      if (pr) pr.textContent = "$" + (p.price / 100).toLocaleString("en-US", { maximumFractionDigits: 0 });
      if (av) av.textContent = p.available ? (card.getAttribute("data-avail-text") || "Available now") : "Sold out"; /* data-avail-text: a card's own wording for an available product, e.g. "Made to order" */
    }).catch(function () { /* keep build-time values */ });
  });

  /* ed_video autoplay loops: if the clip stalls (a short render that stops short of its stated length), restart it rather than freeze on a frame */
  doc.querySelectorAll("[data-video][data-autoplay] video").forEach(function (v) {
    var timer = null;
    function restart() { try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    v.addEventListener("waiting", function () { clearTimeout(timer); timer = setTimeout(function () { if (!v.ended && v.readyState < 3) restart(); }, 1200); });
    v.addEventListener("playing", function () { clearTimeout(timer); });
    v.addEventListener("ended", restart);
    v.addEventListener("pause", function () { if (!v.ended && v.offsetParent) setTimeout(function () { if (v.paused) restart(); }, 800); });
  });
  /* hm_products: arrows scroll the rail one card at a time; disabled at the ends */
  doc.querySelectorAll(".hm-products").forEach(function (sec) {
    var rail = sec.querySelector("[data-rail]"), prev = sec.querySelector("[data-rail-prev]"), next = sec.querySelector("[data-rail-next]"); if (!rail || !prev || !next) return;
    function step() { var c = rail.querySelector(".hm-card"); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) : rail.clientWidth; }
    function sync() { prev.disabled = rail.scrollLeft <= 2; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; }
    prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
    rail.addEventListener("scroll", sync, { passive: true }); window.addEventListener("resize", sync); sync();
  });
  /* hm_compare: before/after slider */
  doc.querySelectorAll("[data-compare]").forEach(function (st) {
    var r = st.querySelector("[data-compare-range]"); if (!r) return;
    function set() { st.style.setProperty("--split", r.value + "%"); }
    r.addEventListener("input", set); set();
  });
  /* ed_video: poster + play button until clicked, then the clip plays with sound and controls */
  doc.querySelectorAll("[data-video]:not([data-autoplay])").forEach(function (f) {
    var v = f.querySelector("video"), b = f.querySelector("[data-video-play]"); if (!v || !b) return;
    b.addEventListener("click", function () { f.classList.add("is-playing"); v.controls = true; v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { /* autoplay policy: controls are visible */ }); });
  });

  /* ---- 3. Section views + sticky purchase action (mobile, after the product module is reached) ---- */
  var sticky = doc.querySelector("[data-sticky]"), product = doc.getElementById("product"), finalCta = doc.getElementById("cta") || doc.querySelector("[data-sticky-stop]"), seen = { lp_view: true }, reached = false; /* lp_view already fired on load */
  function updateSticky() {
    if (!product) { var first = doc.querySelector("section[id]"); reached = !!first && first.getBoundingClientRect().bottom < 0; } /* no order box: show once the hero has scrolled away */
    var atFinal = finalCta && finalCta.getBoundingClientRect().top < window.innerHeight * 0.6;
    var inProduct = product && product.getBoundingClientRect().top < window.innerHeight * 0.5 && product.getBoundingClientRect().bottom > window.innerHeight * 0.5;
    var show = reached && !atFinal && !inProduct && window.matchMedia("(max-width: 819px)").matches;
    if (!sticky) return;
    sticky.classList.toggle("is-visible", show); sticky.setAttribute("aria-hidden", show ? "false" : "true");
    sticky.querySelector("a").tabIndex = show ? 0 : -1; doc.body.classList.toggle("has-sticky", show);
  }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.getAttribute("data-cs-view");
        if (name && !seen[name]) { seen[name] = true; track(name); }
        if (en.target === product) { reached = true; updateSticky(); }
      });
    }, { threshold: 0.2 });
    doc.querySelectorAll("[data-cs-view]").forEach(function (s) { io.observe(s); });
    window.addEventListener("scroll", function () { if (reached || !product) updateSticky(); }, { passive: true });

    /* Section reach: one cs_reach:<section id> tag per section, fired when its top edge passes 60% of the
       viewport. Works for sections of any height. The optimize skill rebuilds each variant's reach curve
       from these tags, in that variant's own section order. */
    var reachSeen = {}, reachIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = en.target.id;
        if (!en.isIntersecting || !id || reachSeen[id]) return;
        reachSeen[id] = true; track("reach", { label: id }); reachIo.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -40% 0px", threshold: 0 });
    doc.querySelectorAll("section[id]").forEach(function (s) { reachIo.observe(s); });
  }

  /* ---- 3b. Order-box gallery: the chosen option's photos with thumbnails and swipe, plus a full-screen viewer.
     Phones: tap a photo to open it. Desktop: the magnifying glass (or a click) opens it. In the viewer, click or tap
     to zoom and move the pointer or finger to look around; arrows, swipe or the keyboard change photo. ---- */
  var showGallery = null;
  var gallery = doc.querySelector("[data-gallery]");
  if (gallery) {
    var rail = gallery.querySelector("[data-gallery-rail]"), thumbs = gallery.querySelector("[data-gallery-thumbs]");
    var prevBtn = gallery.querySelector("[data-gallery-prev]"), nextBtn = gallery.querySelector("[data-gallery-next]");
    var countEl = gallery.querySelector("[data-gallery-count]"), zoomBtn = gallery.querySelector("[data-gallery-zoom]");
    var box = gallery.querySelector("[data-lightbox]"), stage = box && box.querySelector("[data-lightbox-stage]");
    var boxCount = box && box.querySelector("[data-lightbox-count]"), boxImg = null;
    var first = rail.querySelector("img");
    var photos = first ? [{ src: first.getAttribute("src"), alt: first.alt }] : [], current = 0;
    var zoomed = false, base = null, moved = false, startX = 0, startY = 0, scrollTimer;
    function setCurrent(i) {
      current = i;
      [].forEach.call(thumbs.children, function (b, j) { b.setAttribute("aria-current", j === i ? "true" : "false"); });
      countEl.textContent = photos.length > 1 ? (i + 1) + " / " + photos.length : "";
    }
    function go(i, smooth) {
      if (!photos.length) return;
      i = (i + photos.length) % photos.length;
      rail.scrollTo({ left: i * rail.clientWidth, behavior: smooth === false ? "auto" : "smooth" });
      setCurrent(i);
    }
    showGallery = function (list) {
      if (!list || !list.length) return;
      photos = list; rail.innerHTML = ""; thumbs.innerHTML = "";
      list.forEach(function (p, i) {
        var fig = doc.createElement("figure"), im = doc.createElement("img");
        fig.className = "lp-gallery__slide"; im.src = p.src; im.alt = p.alt || ""; im.decoding = "async";
        if (p.w && p.h) { im.width = p.w; im.height = p.h; }
        if (i) im.loading = "lazy";
        fig.appendChild(im); rail.appendChild(fig);
        var b = doc.createElement("button"), t = doc.createElement("img");
        b.type = "button"; b.className = "lp-gallery__thumb"; b.setAttribute("aria-label", "Photo " + (i + 1) + " of " + list.length);
        t.src = p.thumb || p.src; t.alt = ""; t.loading = "lazy"; b.appendChild(t);
        b.addEventListener("click", function () { go(i); track("gallery_thumb", { label: String(i + 1) }); });
        thumbs.appendChild(b);
      });
      var many = list.length > 1;
      thumbs.hidden = !many; prevBtn.hidden = !many; nextBtn.hidden = !many;
      rail.scrollLeft = 0; setCurrent(0);
    };
    rail.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { var i = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth)); if (i !== current && photos[i]) setCurrent(i); }, 60);
    }, { passive: true });
    prevBtn.addEventListener("click", function () { go(current - 1); });
    nextBtn.addEventListener("click", function () { go(current + 1); });
    rail.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(current + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); go(current - 1); }
      if (e.key === "Enter") openBox();
    });
    window.addEventListener("resize", function () { go(current, false); });

    function unzoom() { zoomed = false; if (box) box.classList.remove("is-zoomed"); if (boxImg) { boxImg.style.transform = ""; boxImg.style.transformOrigin = ""; } }
    function aim(x, y) {
      if (!base) return;
      var ox = Math.min(1, Math.max(0, (x - base.left) / base.width)), oy = Math.min(1, Math.max(0, (y - base.top) / base.height));
      boxImg.style.transformOrigin = (ox * 100) + "% " + (oy * 100) + "%";
    }
    function zoomAt(x, y) { base = boxImg.getBoundingClientRect(); zoomed = true; box.classList.add("is-zoomed"); aim(x, y); boxImg.style.transform = "scale(2.5)"; }
    function show(i) {
      current = (i + photos.length) % photos.length;
      var p = photos[current], many = photos.length > 1;
      if (!boxImg) {
        boxImg = doc.createElement("img"); boxImg.draggable = false; stage.appendChild(boxImg);
        boxImg.addEventListener("click", function (e) {
          if (moved) { moved = false; return; }
          if (zoomed) unzoom(); else { zoomAt(e.clientX, e.clientY); track("gallery_zoom", { label: String(current + 1) }); }
        });
      }
      unzoom(); boxImg.src = p.zoom || p.src; boxImg.alt = p.alt || "";
      box.querySelector("[data-lightbox-prev]").hidden = !many; box.querySelector("[data-lightbox-next]").hidden = !many;
      boxCount.textContent = many ? (current + 1) + " / " + photos.length : "";
    }
    function openBox() {
      if (!box || !photos.length) return;
      show(current); doc.documentElement.classList.add("lp-noscroll");
      if (box.showModal) box.showModal(); else box.setAttribute("open", "");
      track("gallery_open", { label: String(current + 1) });
    }
    if (box) {
      box.addEventListener("close", function () { unzoom(); doc.documentElement.classList.remove("lp-noscroll"); go(current, false); });
      box.querySelector("[data-lightbox-close]").addEventListener("click", function () { if (box.close) box.close(); else box.removeAttribute("open"); });
      box.querySelector("[data-lightbox-prev]").addEventListener("click", function () { show(current - 1); });
      box.querySelector("[data-lightbox-next]").addEventListener("click", function () { show(current + 1); });
      box.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") show(current + 1); if (e.key === "ArrowLeft") show(current - 1); });
      stage.addEventListener("click", function (e) { if (e.target === stage && !zoomed && box.close) box.close(); });
      stage.addEventListener("mousemove", function (e) { if (zoomed) aim(e.clientX, e.clientY); });
      stage.addEventListener("touchstart", function (e) { var t = e.touches[0]; startX = t.clientX; startY = t.clientY; moved = false; }, { passive: true });
      stage.addEventListener("touchmove", function (e) {
        if (e.touches.length > 1) return;
        var t = e.touches[0];
        if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) moved = true;
        if (zoomed) { e.preventDefault(); aim(t.clientX, t.clientY); }
      }, { passive: false });
      stage.addEventListener("touchend", function (e) {
        if (zoomed || !moved) return;
        var t = e.changedTouches[0], dx = t.clientX - startX;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(t.clientY - startY)) show(current + (dx < 0 ? 1 : -1));
      });
    }
    rail.addEventListener("click", function (e) { if (e.target.closest(".lp-gallery__slide")) openBox(); });
    zoomBtn.addEventListener("click", openBox);
  }

  /* ---- 4. Configurator: live price/availability, engraving, add to cart → checkout (only on pages with a product) ---- */
  var form = doc.querySelector("[data-configurator]");
  /* Declared outside the if-blocks: the script runs in strict mode, where a function declared inside a block is
     only visible in that block. The submit handler further down (its own if (form) block) needs it too (2026-10-20 fix). */
  function selectedVariant() { var r = form.querySelector("input[name=variant]:checked"); return r ? r.value : null; }
  if (form) {
  var STORE = form.getAttribute("data-store"), HANDLE = form.getAttribute("data-handle");
  var P1 = form.getAttribute("data-engrave-p1"), P2 = form.getAttribute("data-engrave-p2");
  var CHECKOUT_PRICE = form.getAttribute("data-checkout-price") || ""; /* product.checkout_price: shown instead of the live price, which becomes the struck list price */
  var variants = {};
  function money(cents) { return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
  function refreshPrice() {
    var id = selectedVariant(), v = variants[id], r = form.querySelector("input[name=variant]:checked");
    var price = v ? money(v.price) : (r ? r.getAttribute("data-price") : "");
    var shown = CHECKOUT_PRICE || price;
    doc.querySelectorAll("[data-live=price]").forEach(function (n) { n.textContent = shown; });
    doc.querySelectorAll("[data-live=list-price]").forEach(function (n) { n.textContent = price; });
    var st = doc.querySelector("[data-live=price-sticky]"); if (st) st.textContent = shown + " · " + (st.getAttribute("data-fulfillment") || "");
    var av = doc.querySelector("[data-live=availability]"); if (av && v) av.textContent = v.available ? "In stock" : "Sold out";
    form.querySelector("[data-error=stock]").classList.toggle("is-visible", !!(v && !v.available));
  }
  fetch(STORE + "/products/" + HANDLE + ".js", { mode: "cors" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p) return;
      (p.variants || []).forEach(function (v) { variants[String(v.id)] = v; });
      var note = doc.querySelector("[data-live=note]"); if (note) note.textContent = "Price and availability are live from the store.";
      refreshPrice();
    }).catch(function () { /* keep build-time values */ });
  // Options that are separate products (a collection page) carry their own title, photo and product page link.
  function refreshOption() {
    var r = form.querySelector("input[name=variant]:checked"); if (!r) return;
    var t = r.getAttribute("data-title"), src = r.getAttribute("data-img"), url = r.getAttribute("data-url");
    if (t) doc.querySelectorAll("[data-live=title]").forEach(function (n) { n.textContent = t; });
    // the option's photos: its gallery (own photo first), else its single photo; pages without either keep the section photo
    var list = [];
    try { list = JSON.parse(r.getAttribute("data-gallery") || "[]"); } catch (err) { list = []; }
    if (!list.length && src) list = [{ src: src, alt: r.getAttribute("data-img-alt") || "" }];
    if (showGallery) showGallery(list);
    else { var im = doc.querySelector(".lp-product__media img"); if (im && src && im.getAttribute("src") !== src) { im.src = src; im.alt = r.getAttribute("data-img-alt") || im.alt; } }
    var pdp = form.querySelector("[data-live=pdp]");
    if (pdp && url) { var q = pdp.href.indexOf("?"); pdp.href = url + (q > -1 ? pdp.href.slice(q) : ""); }
  }
  form.addEventListener("change", function (e) { if (e.target.name === "variant") { refreshPrice(); refreshOption(); track("variant_select", { label: e.target.value }); } });
  refreshPrice(); refreshOption();
  } /* end of the order-box-only part. The engraving preview below also runs on pages that have an engraving section but no order box (2026-10-19, Built for Pilots). */

  // Engraving: the configurator fields and the engraving-section fields are the same values, kept in sync.
  var toggle = form ? form.querySelector("[data-engrave-toggle]") : null, fields = form ? form.querySelector("[data-engrave-fields]") : null, confirmBox = form ? form.querySelector("[data-engrave-confirm]") : null;
  var preview = doc.querySelector("[data-engrave-preview]"), previewText = preview && preview.querySelector(".lp-engrave__text"), cover = preview && preview.querySelector(".lp-engrave__cover"), badge = preview && preview.querySelector("[data-engrave-badge]");
  var interacted = false;
  var firstLine = doc.querySelector("[data-engrave-line]"), MAX = firstLine ? (parseInt(firstLine.getAttribute("maxlength"), 10) || 12) : 12;
  function clean(s) { return s.toUpperCase().replace(/[^A-Z0-9 .,'&#\-]/g, "").slice(0, MAX); }
  function lineValue(n) { var i = doc.querySelector("[data-engrave-line='" + n + "']"); return i ? i.value : ""; }
  function syncLine(n, val, source) {
    doc.querySelectorAll("[data-engrave-line='" + n + "']").forEach(function (i) { if (i !== source) i.value = val; });
    doc.querySelectorAll("[data-count='" + n + "']").forEach(function (c) { c.textContent = val.length; });
    var pv = doc.querySelector("[data-preview='" + n + "']"); if (pv) pv.textContent = val;
    var custom = (lineValue(1) + lineValue(2)).length > 0;
    if (preview) { previewText.hidden = !custom; cover.hidden = !custom; badge.textContent = custom ? "Your engraving (preview)" : "Example engraving"; fitPreview(); }
    if (custom && toggle && !toggle.checked) { toggle.checked = true; fields.hidden = false; }
    if (!interacted && custom) { interacted = true; track("engraving_interaction"); }
  }
  // Long lines of wide letters (up to 16 per line) can outgrow the caseback patch: shrink the preview text just enough to stay on it.
  function fitPreview() {
    if (!preview || previewText.hidden) return;
    previewText.style.fontSize = "";
    var room = cover.offsetWidth * 0.92, widest = 0;
    previewText.querySelectorAll("span").forEach(function (s) { widest = Math.max(widest, s.offsetWidth); });
    if (widest > room) previewText.style.fontSize = (parseFloat(getComputedStyle(previewText).fontSize) * room / widest) + "px";
  }
  if (preview) window.addEventListener("resize", fitPreview);
  doc.addEventListener("input", function (e) {
    var inp = e.target; if (!inp.matches("[data-engrave-line]")) return;
    var val = clean(inp.value); if (val !== inp.value) inp.value = val;
    syncLine(inp.getAttribute("data-engrave-line"), val, inp);
  });
  if (toggle) toggle.addEventListener("change", function () {
    fields.hidden = !toggle.checked;
    if (!toggle.checked) { syncLine("1", "", null); syncLine("2", "", null); doc.querySelectorAll("[data-engrave-line]").forEach(function (i) { i.value = ""; }); confirmBox.checked = false; }
    else { var first = fields.querySelector("[data-engrave-line='1']"); if (first) first.focus(); track("engraving_interaction", { label: "toggle" }); }
    form.querySelector("[data-error=engrave]").classList.remove("is-visible");
  });

  if (form) {
  // Add to cart: Shopify accepts GET /cart/add with line-item properties and cart attributes, then redirects to return_to.
  // return_to is the store's cart page (Beau, 2026-10-05): shoppers see and adjust the cart, then start checkout there, so the page
  // counts add_to_cart and Shopify counts checkouts. Until then it was /checkout and the page also fired checkout_start on submit.
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var id = selectedVariant(); if (!id) return;
    var v = variants[id]; if (v && !v.available) { form.querySelector("[data-error=stock]").classList.add("is-visible"); return; }
    var wantEngraving = toggle && toggle.checked, l1 = clean(lineValue(1)), l2 = clean(lineValue(2));
    var engraveErr = form.querySelector("[data-error=engrave]");
    if (wantEngraving && (!(l1 || l2) || !confirmBox.checked)) { engraveErr.classList.add("is-visible"); (l1 || l2 ? confirmBox : fields.querySelector("[data-engrave-line='1']")).focus(); return; }
    if (engraveErr) engraveErr.classList.remove("is-visible");
    var u = new URL(STORE + "/cart/add");
    u.searchParams.set("id", id); u.searchParams.set("quantity", "1");
    if (wantEngraving) { if (l1) u.searchParams.set("properties[" + P1 + "]", l1); if (l2) u.searchParams.set("properties[" + P2 + "]", l2); }
    u.searchParams.set("attributes[landing_page]", CAMPAIGN + "/" + VARIANT);
    carried.forEach(function (kv) { u.searchParams.set("attributes[" + kv[0] + "]", kv[1]); });
    u.searchParams.set("return_to", "/cart");
    track("add_to_cart", { label: wantEngraving ? "engraved" : "plain", variant_id: id });
    location.href = u.toString();
  });
  }
})();
